module.exports = __webpack_public_path__ + "static/media/Group237657.ffd5663c.webp";